package com.example.mystybag.sharedmodels.project.responseModels.reservations

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class CreateReviewResponseModel(
    val reviewId: Long = 0L
) : BaseResponseModel()

